import * as actionType from '../ActionTypes';
import * as mutationType from '../MutationType';
import api from '../../config/api';

const state = {
	unreadMessages: 0
};
const getters = {
	unreadMessages: state => state.unreadMessages
};

const actions = {
	[actionType.GET_CHAT_HISTORY_USER]: async function({ commit }, params) {
		
		return new Promise((resolve, reject) => {
			api(`/chat/history?admin=${params.admin}`, {
				method: 'GET',
				params: {
					query: params.query,
					take: params.take,
					page: params.page
				}
			})
				.then(result => {
					resolve(result);
				})
				.catch(error => reject(error));
		});
	},

	[actionType.GET_CHAT]: async function({ commit }, params) {
		return new Promise((resolve, reject) => {
			api(`/chat/${params.chatId}?admin=${params.admin}`, {
				method: 'GET',
				params: {
					page: params.page,
					take: params.take,
					orderBy: 'desc'
				}
			})
				.then(result => {
					resolve(result);
				})
				.catch(error => reject(error));
		});
	},
	[actionType.BLOCK_USER]: async function({ commit }, params) {
		
		return new Promise((resolve, reject) => {
			api
				.post(`/chat/block?admin=${params.admin}`, params)
				.then(result => {
					resolve(result);
				})
				.catch(error => reject(error));
		});
	},
	[actionType.SEND_CHAT_MESSAGE]: async function({ commit }, params) {
		return new Promise((resolve, reject) => {
			api
				.post(`/chat/message?admin=${params.admin}`, params.formData)
				.then(result => {
					resolve(result.data.data);
				})
				.catch(error => reject(error));
		});
	},
	[actionType.GET_NUMBER_OF_UNREAD_MESSAGE]: async function(
		{ commit },
		params
	) {
		
		return new Promise((resolve, reject) => {
			api
				.get(`/chat/unread?admin=${params.admin}`)
				.then(result => {
					commit('SET_UNREAD_MESSAGE', result.data.data.unreadMessages);
				})
				.catch(error => reject(error));
		});
	}
};

const mutations = {
	SET_UNREAD_MESSAGE: function(state, data) {
		
		state.unreadMessages = data;
	}
};
export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
